import {Component, Input, Inject, OnInit, ElementRef, ViewChild} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import { ProfileHttp } from '../../../tsScripts/providers/http/ProfileHttp';
import { ErrorDTO } from '../../../tsScripts/DTO/ErrorDTO';
import { MessageStorage } from '../../../tsScripts/util/MessageStorage';
import { Aws } from '../../../tsScripts/providers/services/aws';

@Component({
    selector: 'modal-change-my-profile-photo',
    templateUrl: "../../../views/components/myProfile/modalChangeMyProfilePhoto.html",
    providers: [],
    styleUrls: ["../../../styles/agent.css"]
})

export class ModalChangeMyProfilePhoto implements OnInit {

    loadingEdit: boolean;
    error: boolean;
    errorMessage: string;
    active: number;

    imageSrc: any;

    @ViewChild("filechoser")
    filechoser: ElementRef;

    @Input()
    agentId: string;

    constructor(private ProfileHttp: ProfileHttp,
                private activeModal: NgbActiveModal,
                private aws: Aws) {
        this.loadingEdit = false;
        this.error = false;
        this.imageSrc = "images/format_image.png";
    }

    cancel() {
        this.activeModal.close();
    }


    imageChange() {
        let fileSelected = this.filechoser.nativeElement.files[0];
        let reader: FileReader = new FileReader();
        reader.onloadend = () => {
            this.imageSrc = reader.result;
        }
        reader.readAsDataURL(fileSelected);
    }

    uploadImage() {
        this.loadingEdit = true;
        if (this.filechoser.nativeElement.files.length>0 && this.filechoser.nativeElement.files[0].type.indexOf("image") >= 0) {
            if (this.filechoser.nativeElement.files[0].size <= 5000000) {
                this.aws.uploadFile(this.filechoser.nativeElement,
                    (response: any) => {
                        this.updateProfilePhoto(response.fileKey);
                    },
                    (error: ErrorDTO) => {
                        this.error = true;
                        this.loadingEdit = false;
                        this.errorMessage = error.errorMessage;
                    });
            } else {
                this.error = true;
                this.loadingEdit = false;
                this.errorMessage = "La imagen no puede pesar más de 5 MB";
            }
        } else {
            this.error = true;
            this.loadingEdit = false;
            this.errorMessage = "Debe seleccionar una imagen";
        }
    }
    
    private updateProfilePhoto(fileKey: string){
        let param: any = {
            agentId: this.agentId,
            profileImageId: fileKey
        }
        this.ProfileHttp.editProfileImage(param).then((response: any) => {
            MessageStorage.add("success", "La foto ha sido actualizada");
            this.loadingEdit = false;
            this.activeModal.dismiss(response.profileImageUrl);
        }, (error: ErrorDTO) => {
            this.error = true;
            this.loadingEdit = false;
            this.errorMessage = error.errorMessage;
        });
    }

    ngOnInit() {
    }
}